/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Relations/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Relations({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Relations",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#A057DA"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Relations.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-Z2x5P9T': alignSelf,'--mt-2-Z2x5P9T': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2x5P9T': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2x5P9T': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2x5P9T': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2x5P9T': opacity,'--w-10-Z2x5P9T': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2x5P9T': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2x5P9T': fill,'--a-7-Z2x5P9T': isAnimated ? animation : "none",'--sd-8-Z2x5P9T': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2x5P9T': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Relations.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8 4a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0zM2.5 10v1a1 1 0 001 1H4l.439 3.57a.5.5 0 00.495.43h2.132a.5.5 0 00.495-.43L8 12h2l.439 3.57a.5.5 0 00.495.43h2.132a.5.5 0 00.495-.43L14 12h.5a1 1 0 001-1v-1a3 3 0 00-3-3h-7a3 3 0 00-3 3z"
 style={{'--f-12-Z2x5P9T': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}